import { Outlet, Route, Routes } from 'react-router-dom'

import { PageTitle } from '../../../../_metronic/layout/core'
import { EnderecosListWrapper } from './enderecos-list/EnderecosList'

export const EnderecosPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        {/* `origem` diz de qual listagem o usuário veio (instituicao | entidade | unidade) e
            define quais endpoints de endereço a tela usa. */}
        <Route
          path=':origem/:id'
          element={
            <>
              <PageTitle>Endereços</PageTitle>
              <EnderecosListWrapper />
            </>
          }
        />
      </Route>
    </Routes>
  )
}

export default EnderecosPage
